
<script>
import Utils from "../utils/Utils";
import wx from "weixin-js-sdk";

export default {
  name: "MiniOauthRedirect",
  mounted: function() {
    this.app = Utils.getApp();
    wx.miniProgram.redirectTo({
      url: '/pages/oauth/oauth'
    });
  },
}
</script>

<style scoped>

</style>